
define('text!fusion/ui/controls/fusion-expander.html',[],function () { return '<div>\r\n   <dl class="accordion" data-accordion>\r\n       <!-- ko transclude --> <!-- /ko -->\r\n  </dl>\r\n</div>\r\n';});

